/*
 * @Author:
 * @Description:
 * @Date: 2025-06-09 16:31:01
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/api/networkApplication/step-status.js
 */
/*
 * @Author:
 * @Description:
 * @Date: 2025-05-26 18:55:02
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/api/networkApplication/step-companyDetails.js
 */
import http from '@/utils/http';
import { getLocalStorage } from '@/utils/tools/utils';
// /approveTask/getApproveTaskByAssociationId
export function getApproveTaskByAssociationId(userId) {
  const _userId = userId || JSON.parse(getLocalStorage('userLogin'))?.userId;
  return http.get(`/approveTask/getApproveTaskByAssociationId?associationId=${_userId}`);
}
